import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';

@Pipe({
    name: 'wholesalerUnableToTransfer',
    standalone: false
})
export class WholesalerUnableToTransferPipe implements PipeTransform {

  transform(bomModels: IBomModel[]): IBomModel[] {
    return bomModels?.filter(m => !m.article.canTransferToWholesaler);
  }

}
